import { render, staticRenderFns } from "./LayoutPrint.vue?vue&type=template&id=628b5c5e"
import script from "./LayoutPrint.vue?vue&type=script&lang=js"
export * from "./LayoutPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports